import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function HotList() {
  const hot = [...articles].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-3.5">
        <div className="flex items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded bg-primary-500 text-background-50">
            <i className="ri-fire-line text-sm" />
          </span>
          <h2 className="font-heading text-base font-bold text-foreground-950">热点速览 · 24 小时</h2>
        </div>
        <span className="text-xs text-foreground-500">按关注度排序</span>
      </div>
      <div className="divide-y divide-background-200 px-2">
        {hot.map((article, index) => (
          <ArticleCard key={article.slug} article={article} variant="compact" rank={index + 1} />
        ))}
      </div>
    </section>
  );
}